import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';

import AddressItem from './components/AddressItem';

const propTypes = {
  accountCard: PropTypes.shape({
    id: PropTypes.string,
    roster_identity_linked_identity_addresses: PropTypes.shape({
      total: PropTypes.number,
      records: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          name: PropTypes.string,
          address_line_1: PropTypes.string,
          address_line_2: PropTypes.string,
          city: PropTypes.string,
          state: PropTypes.string,
          post_code: PropTypes.string,
          country: PropTypes.shape({
            name: PropTypes.string,
          }),
        }),
      ),
    }),
    external_shipping_addresses: PropTypes.shape({
      total: PropTypes.number,
      records: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          name: PropTypes.string,
          address_line_1: PropTypes.string,
          address_line_2: PropTypes.string,
          city: PropTypes.string,
          state: PropTypes.string,
          post_code: PropTypes.string,
          country: PropTypes.shape({
            name: PropTypes.string,
          }),
        }),
      ),
    }),
    external_shipping_address: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      address_line_1: PropTypes.string,
      address_line_2: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      post_code: PropTypes.string,
      country: PropTypes.shape({
        name: PropTypes.string,
      }),
    }),
  }),
};

const AccountCardAddresses = ({ accountCard }) => {
  const totalSentTo =
    (accountCard?.roster_identity_linked_identity_addresses?.total ?? 0) +
    (accountCard?.external_shipping_addresses?.total ?? 0) +
    (accountCard?.external_shipping_address ? 1 : 0);

  return (
    <Fragment>
      <h3 className="text-center">
        {pluralize('recipient', totalSentTo, true)}
      </h3>
      <div className="account-card-addresses-container">
        {(
          accountCard?.roster_identity_linked_identity_addresses?.records ?? []
        ).map(rosterIdentityLinkedIdentityAddress => (
          <AddressItem
            key={rosterIdentityLinkedIdentityAddress.id}
            address={rosterIdentityLinkedIdentityAddress}
          />
        ))}
        {(accountCard?.external_shipping_addresses?.records ?? []).map(
          externalShippingAddress => (
            <AddressItem
              key={externalShippingAddress.id}
              address={externalShippingAddress}
            />
          ),
        )}
        {accountCard?.external_shipping_address && (
          <AddressItem address={accountCard?.external_shipping_address} />
        )}
      </div>
    </Fragment>
  );
};

AccountCardAddresses.propTypes = propTypes;

export default AccountCardAddresses;
